import React, { useEffect, useState } from 'react'
import apiClient from '../../utils/apiclient'
import Restaurant from "../../components/restaurants/index"
import Navbar from "../../components/NavBar/Index"
import { useNavigate } from 'react-router-dom'

const Index = () => {
    const navigate=useNavigate()
   useEffect(() => {
      if (!localStorage.getItem("bentoAdmin")) {
        navigate("/login")
      }
    }, [navigate])
  
    const [data,setData]=useState([]);
    useEffect(()=>{
        const fetchdata = async()=>{
            try{
                const response= await apiClient.get("restaurant/mealsnotaddedtoday");
                setData(response.data);
                
                console.log(response.data);
                
            }
            catch(e){
                console.error(e)
            }
        }
        fetchdata()
    },[])
  return (
    <div className='flex flex-1 flex-col overflow-hidden px-2 md:px-4'>
      <div className='flex-1 flex flex-col min-h-0 mt-2 overflow-hidden'> 
        <Restaurant data={data} />
      </div>
    </div> 
  )
}

export default Index